import PropTypes from 'prop-types';
import React from 'react';
import T from 'components/T';

const Status = ({ status }) => (
  <span className={`text-capitalize cp-badge cp-badge-${status}`}>
    <T value={`badges.${status}`} />
  </span>
);

Status.propTypes = {
  status: PropTypes.string.isRequired,
};

export default Status;
